import { InjectionToken } from '@angular/core';

export interface UzurvRestConfiguration {
  claraApiUrl: string;
  dotsApiUrl: string;
  reportingApiUrl: string;
  googleMapsApiKey: string;
  httpDebugMode: boolean;
}

export const UZURV_REST_CONFIGURATION = new InjectionToken<UzurvRestConfiguration>('UzurvRestConfiguration');
